import React from 'react';

import Badge, {BadgeColor} from 'ui-library/Badge';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface BufferNavItemProps {
  closeable: boolean;
  title: string | null;
  inBeta: boolean;
}

function BufferNavItem({closeable, title, inBeta}: BufferNavItemProps): JSX.Element {
  return (
    <div>
      <div className="sectionTabs-navItem-title">
        <span className="sectionTabs-navItem-title-inner">{title || '-'}</span>
      </div>
      {inBeta && (
        <span className="sectionTabs-navItem-title u-tiny-spacing-left">
          <Badge color={BadgeColor.GREEN}>beta</Badge>
        </span>
      )}
      {closeable && <div className="sectionTabs-navItem-closeBtn js-sectionTabs-close" />}
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<BufferNavItemProps>(BufferNavItem);
